import styled from 'styled-components';
import UITable from 'UIComponents/table/UITable';
import GutterContainer from './GutterContainer';
import { NEXT_COMPONENT_SPACING } from 'developer-docs-shared-components/config/cssConstants';
import { ContainerContext } from '../utils/ContainerContext';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const Spacer = styled.div.withConfig({
  displayName: "Table__Spacer",
  componentId: "sc-1aw9jp0-0"
})(["margin-bottom:", "px;"], NEXT_COMPONENT_SPACING);
const Table = ({
  children,
  size = 'large',
  style,
  bordered
}) => /*#__PURE__*/_jsx(ContainerContext.Provider, {
  value: "table",
  children: /*#__PURE__*/_jsx(GutterContainer, {
    size: size,
    children: /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "800",
      children: /*#__PURE__*/_jsx(UITable, {
        style: style,
        bordered: bordered,
        children: children
      })
    })
  })
});
export default Table;